export const DIVISIONS = [
    { id: 'ADMIN', name: 'ADMIN', fullName: 'Administration & Finance', color: '#6366f1' },
    { id: 'AGRI', name: 'AGRI', fullName: 'Agriculture', color: '#22c55e' },
    { id: 'AIC', name: 'AIC', fullName: 'ASEAN-India Centre', color: '#f59e0b' },
    { id: 'BE', name: 'BE', fullName: 'Blue Economy', color: '#0ea5e9' },
    { id: 'CMEC', name: 'CMEC', fullName: 'Center for Maritime Economy and Connectivity', color: '#1a73e8' },
    { id: 'CONNECTIVITY', name: 'CONNECTIVITY', fullName: 'Connectivity', color: '#14b8a6' },
    { id: 'DAKSHIN', name: 'DAKSHIN', fullName: 'DAKSHIN - Global South Centre of Excellence', color: '#d93025' },
    { id: 'DC', name: 'DC', fullName: 'Development Cooperation', color: '#8b5cf6' },
    { id: 'FINANCE', name: 'FINANCE', fullName: 'Finance & FinTech', color: '#10b981' },
    { id: 'FITM', name: 'FITM', fullName: 'Forum on Indian Traditional Medicine', color: '#34a853' },
    { id: 'IT', name: 'IT', fullName: 'Information Technology', color: '#3b82f6' },
    { id: 'PUB', name: 'Publication', fullName: 'Publication & Media', color: '#ec4899' },
    { id: 'RIS', name: 'RIS', fullName: 'Research & Information System (Central)', color: '#1e3a8a' },
    { id: 'SCIENCE', name: 'SCIENCE', fullName: 'Science Diplomacy', color: '#7c3aed' },
    { id: 'SDG', name: 'SDGs', fullName: 'Sustainable Development Goals', color: '#059669' },
    { id: 'SM', name: 'Social Media', fullName: 'Social Media', color: '#f43f5e' },
    { id: 'STD', name: 'Standard', fullName: 'Standard', color: '#b45309' },
    { id: 'TIWTO', name: 'TIWTO', fullName: 'Trade, Investment & WTO', color: '#0891b2' },
];

export const ORGANOGRAM_HIERARCHY = [
    {
        id: 'DEV_COOP',
        name: 'Development Cooperation',
        color: '#8b5cf6',
        strategicUnit: 'RIS + DAKSHIN',
        collectiveLead: 'Dr. Sushil Kumar',
        areas: [
            { id: 'DC', name: 'Development Cooperation (SS +Triangular)', lead: 'Dr. Sushil Kumar' },
            { id: 'DC_IMPL', name: 'DC Implementation', lead: 'Dr. R.S. Ratna', parentDivId: 'DC' }
        ]
    },
    {
        id: 'SDG_PILLAR',
        name: 'SDGs-Life',
        color: '#059669',
        strategicUnit: 'RIS',
        collectiveLead: 'Dr. Sabyasachi Saha',
        areas: [
            { id: 'SDG', name: 'Sustainable Development Goals', lead: 'Dr. Sabyasachi Saha' }
        ]
    },
    {
        id: 'TRADE_INV',
        name: 'Trade and Investment',
        color: '#0891b2',
        strategicUnit: 'RIS',
        collectiveLead: 'Dr. Atul Kaushik | Dr. Pankaj Vashisht',
        areas: [
            { id: 'TIWTO', name: 'WTO | IPR | BITS | Govt Procurement', lead: 'Dr. Atul Kaushik' },
            { id: 'STD', name: 'Standards', lead: 'Mr. Anil Jauhri' },
            { id: 'TRADE_FAC', name: 'Trade Facilitation', lead: 'Dr. Prabir De', parentDivId: 'TIWTO' },
            { id: 'SUSTAINABILITY', name: 'Sustainability', lead: 'Ms. Lakshmi Swathi | Dr. Atul Kaushik | Dr. Sachin Kumar Sharma', parentDivId: 'TIWTO' },
            { id: 'TRADE_TECH', name: 'Trade and Technology', lead: 'Dr. Sabyasachi Saha', parentDivId: 'TIWTO' },
            { id: 'IND_DIGITAL', name: 'Industry & Digital trade', lead: 'Dr. Pankaj Vashisht', parentDivId: 'TIWTO' },
            { id: 'FTA_MINERALS', name: 'FTAs & Critical Minerals', lead: 'Dr. Sachin Kumar Sharma | Dr. R.S. Ratna | Dr. Pankaj Vashisht', parentDivId: 'TIWTO' }
        ]
    },
    {
        id: 'MARITIME_CONN',
        name: 'Maritime Economy & Connectivity',
        color: '#1a73e8',
        strategicUnit: 'RIS + CMEC',
        collectiveLead: 'Cmdre. Sujeet Samaddar',
        areas: [
            { id: 'CMEC', name: 'CMEC', lead: 'Dr. Shishir Shrotriya' },
            { id: 'CONNECTIVITY', name: 'Connectivity', lead: 'Dr. Prabir De' },
            { id: 'BE', name: 'Blue Economy', lead: 'Dr. Pankhuri Gaur' },
            { id: 'MARITIME_CONN_SUB', name: 'Maritime Connectivity', lead: 'Cmdre. Sujeet Samaddar', parentDivId: 'CONNECTIVITY' }
        ]
    },
    {
        id: 'FINANCE_PILLAR',
        name: 'Finance',
        color: '#10b981',
        strategicUnit: 'RIS',
        collectiveLead: 'Dr. Priyadarshi Dash',
        areas: [
            { id: 'FINANCE', name: 'Finance', lead: 'Dr. Priyadarshi Dash' }
        ]
    },
    {
        id: 'HEALTH_PILLAR',
        name: 'Health',
        color: '#34a853',
        strategicUnit: 'RIS + DAKSHIN',
        collectiveLead: 'Dr. Sarin',
        areas: [
            { id: 'FITM', name: 'Forum on Indian Traditional Medicine', lead: 'Dr. Sarin' },
            { id: 'HEALTH_DAKSHIN', name: 'Health (DAKSHIN)', lead: 'Dr. Monika Kochhar', parentDivId: 'DAKSHIN' }
        ]
    },
    {
        id: 'SCIENCE_TECH',
        name: 'Science and Technology',
        color: '#7c3aed',
        strategicUnit: 'RIS + DAKSHIN',
        collectiveLead: 'Dr. Amit Kumar',
        areas: [
            { id: 'SCIENCE', name: 'Science and Diplomacy', lead: 'Dr. Amit Kumar' },
            { id: 'AI_DIGITAL_DAKSHIN', name: 'AI | Digital (DAKSHIN)', lead: 'DAKSHIN Advisor', parentDivId: 'DAKSHIN' }
        ]
    },
    {
        id: 'AGRI_PILLAR',
        name: 'Agriculture',
        color: '#22c55e',
        strategicUnit: 'RIS + DAKSHIN',
        collectiveLead: 'Dr. P S Birthal',
        areas: [
            { id: 'AGRI', name: 'Agriculture', lead: 'Dr. P S Birthal' },
            { id: 'TRADE_AGRI', name: 'Trade and Agriculture', lead: 'Dr. Sachin Kumar Sharma', parentDivId: 'AGRI' }
        ]
    }
];

export const STRATEGIC_HIERARCHY = [
    {
        id: 'RIS_STRATEGIC',
        name: 'RIS',
        color: '#1e3a8a',
        strategicUnit: 'RIS',
        collectiveLead: 'Dr. Sabyasachi Saha | Dr. Atul Kaushik | Dr. Pankaj Vashisht | Dr. Priyadarshi Dash | Dr. Amit Kumar',
        areas: [
            { id: 'SDG', name: 'Sustainable Development Goals', lead: 'Dr. Sabyasachi Saha' },
            { id: 'TIWTO', name: 'WTO | IPR | BITS | Govt Procurement', lead: 'Dr. Atul Kaushik' },
            { id: 'STD', name: 'Standards', lead: 'Mr. Anil Jauhri' },
            { id: 'TRADE_FAC', name: 'Trade Facilitation', lead: 'Dr. Prabir De', parentDivId: 'TIWTO' },
            { id: 'SUSTAINABILITY', name: 'Sustainability', lead: 'Ms. Lakshmi Swathi | Dr. Atul Kaushik | Dr. Sachin Kumar Sharma', parentDivId: 'TIWTO' },
            { id: 'TRADE_TECH', name: 'Trade and Technology', lead: 'Dr. Sabyasachi Saha', parentDivId: 'TIWTO' },
            { id: 'IND_DIGITAL', name: 'Industry & Digital trade', lead: 'Dr. Pankaj Vashisht', parentDivId: 'TIWTO' },
            { id: 'FTA_MINERALS', name: 'FTAs & Critical Minerals', lead: 'Dr. Sachin Kumar Sharma | Dr. R.S. Ratna | Dr. Pankaj Vashisht', parentDivId: 'TIWTO' },
            { id: 'FINANCE', name: 'Finance', lead: 'Dr. Priyadarshi Dash' },
            { id: 'SCIENCE', name: 'Science and Diplomacy', lead: 'Dr. Amit Kumar' }
        ]
    },
    {
        id: 'RIS_DAKSHIN_STRATEGIC',
        name: 'RIS + DAKSHIN',
        color: '#d93025',
        strategicUnit: 'RIS + DAKSHIN',
        collectiveLead: 'Dr. Sushil Kumar | Dr. Sarin | Dr. P S Birthal',
        areas: [
            { id: 'DC', name: 'Development Cooperation (SS +Triangular)', lead: 'Dr. Sushil Kumar' },
            { id: 'DC_IMPL', name: 'DC Implementation', lead: 'Dr. R.S. Ratna', parentDivId: 'DC' },
            { id: 'FITM', name: 'Forum on Indian Traditional Medicine', lead: 'Dr. Sarin' },
            { id: 'HEALTH_DAKSHIN', name: 'Health (DAKSHIN)', lead: 'Dr. Monika Kochhar', parentDivId: 'DAKSHIN' },
            { id: 'AI_DIGITAL_DAKSHIN', name: 'AI | Digital (DAKSHIN)', lead: 'DAKSHIN Advisor', parentDivId: 'DAKSHIN' },
            { id: 'AGRI', name: 'Agriculture', lead: 'Dr. P S Birthal' },
            { id: 'TRADE_AGRI', name: 'Trade and Agriculture', lead: 'Dr. Sachin Kumar Sharma', parentDivId: 'AGRI' }
        ]
    },
    {
        id: 'RIS_CMEC_STRATEGIC',
        name: 'RIS + CMEC',
        color: '#1a73e8',
        strategicUnit: 'RIS + CMEC',
        collectiveLead: 'Cmdre. Sujeet Samaddar',
        areas: [
            { id: 'CMEC', name: 'CMEC', lead: 'Dr. Shishir Shrotriya' },
            { id: 'CONNECTIVITY', name: 'Connectivity', lead: 'Dr. Prabir De' },
            { id: 'BE', name: 'Blue Economy', lead: 'Dr. Pankhuri Gaur' },
            { id: 'MARITIME_CONN_SUB', name: 'Maritime Connectivity', lead: 'Cmdre. Sujeet Samaddar', parentDivId: 'CONNECTIVITY' }
        ]
    }
];
